/** @jsxImportSource @emotion/react */
import Layout from "components/Layout"
import { Box, Typography, Divider, Container } from "@mui/material"
import { PrivacyPolicyPageStyle } from "appearance"

const PrivacyPolicyPage = () => {
  const html = `<div class=WordSection1>
  <style>
  <!--
   /* Style Definitions */
   p.MsoListParagraph, li.MsoListParagraph, div.MsoListParagraph
      {margin-top:0in;
      margin-right:0in;
      margin-bottom:0in;
      margin-left:.5in;
      font-size:12.0pt;
      font-family:"Calibri",sans-serif;
      color:white;
      border:none;}
  p.BodyA, li.BodyA, div.BodyA
      {mso-style-name:"Body A";
      margin:0in;
      font-size:12.0pt;
      font-family:"Calibri",sans-serif;
      color:white;
      border:none;}
  .MsoChpDefault
      {font-size:10.0pt;
      border:none;}
   /* Page Definitions */
   @page WordSection1
      {size:8.5in 11.0in;
      margin:1.0in 1.0in 1.0in 1.0in;}
  div.WordSection1
      {page:WordSection1;}
   /* List Definitions */
   ol
      {margin-bottom:0in;}
  ul
      {margin-bottom:0in;}
  -->
  </style>
  
  <p class=BodyA align=center style='text-align:center'><b><u><span
  style='font-family:Poppins,Roboto'>General Terms of Sale</span></u></b></p>
  
  <p class=BodyA align=center style='text-align:center'><span style='font-family:
  Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>BY COMPLETING
  A PURCHASE ON TRIBLY, YOU AGREE TO THESE GENERAL TERMS OF SALE.</span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><b><span style='font-family:
  Poppins,Roboto'>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><u><span style='font-family:Poppins,Roboto'>Subject
  and Scope</span></u></b></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>These General
  Terms of Sale (hereinafter referred to as “<b><u>TOS</u></b>”) apply to all
  purchase orders you place on the Tribly online platform (hereinafter referred
  to as the “<b><u>Tribly Platform</u></b>”) and your subsequent purchase
  agreement with Fan Space, LLC, a Mississippi limited liability company d/b/a
  Tribly (hereinafter referred to as “Tribly”) regarding your purchase of certain
  non-fungible tokens (collectively referred to as “<b><u>NFTs</u></b>”).</span></p>
  
  <p class=MsoListParagraph><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>In addition to
  these TOS, the Tribly Website Terms of Use and Privacy Policy shall also apply.
  </span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><b><span style='font-family:
  Poppins,Roboto'>2.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><u><span style='font-family:Poppins,Roboto'>Order
  Process and Conclusion of Purchase Agreement</span></u></b></p>
  
  <p class=MsoListParagraph><b><u><span style='font-family:Poppins,Roboto'><span
   style='text-decoration:none'>&nbsp;</span></span></u></b></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>The NFT
  presentation on the Tribly Platform does not represent an offer but shall be
  understood as a non-binding invitation for the customer to submit an order.</span></p>
  
  <p class=MsoListParagraph><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>By clicking the
  “Buy now” button, you are sending us a binding offer for the conclusion of a
  purchase order with Tribly regarding the NFT items in your shopping cart
  (hereinafter referred to as “<b><u>Order</u></b>”).</span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>Tribly may, at
  its discretion, accept or reject the Order. Tribly will accept your Order by
  sending an order confirmation or simply by delivering the ordered NFTs to you
  through our third party affiliate, Venly. Unless otherwise stated, the
  effective date of the purchase agreement is the date on which Tribly confirms
  by email the acceptance of your Order. </span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>d)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>If you place an
  Order through the Tribly Platform, the ordering process comprises four steps:</span></p>
  
  <p class=MsoListParagraph style='margin-left:6.0pt;text-indent:60.0pt'><span
  style='font-family:Poppins,Roboto'>i.</span><span style='font-family:
  Poppins,Roboto'>You select the desired goods (NFTs).</span></p>
  
  <p class=MsoListParagraph style='margin-left:1.0in'><span style='font-family:
  Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='margin-left:6.0pt;text-indent:60.0pt'><span
  style='font-family:Poppins,Roboto'>ii.</span><span style='font-family:
  Poppins,Roboto'>You check all items in your shopping cart and apply
  any necessary changes. You click the “Check out” button to proceed to payment.</span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='margin-left:6.0pt;text-indent:60.0pt'><span
  style='font-family:Poppins,Roboto'>iii.</span><span style='font-family:
  Poppins,Roboto'>If you have not already done so, you log into your
  user account with email and password and enter the required customer data for
  the transaction.</span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='margin-left:6.0pt;text-indent:60.0pt'><span
  style='font-family:Poppins,Roboto'>iv.</span><span style='font-family:
  Poppins,Roboto'>Finally, on the “Checkout” page, you select the
  preferred method of payment and confirm your acceptance of the conditions that
  shall apply to the purchase. Here, you can again change the invoice details,
  check your purchase data and return to the cart by clicking “Back to cart”. By
  clicking “Buy now”, your Order becomes binding, final, and non-refundable.</span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><b><span style='font-family:
  Poppins,Roboto'>3.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><u><span style='font-family:Poppins,Roboto'>Prices
  and Taxes</span></u></b></p>
  
  <p class=MsoListParagraph><b><u><span style='font-family:Poppins,Roboto'><span
   style='text-decoration:none'>&nbsp;</span></span></u></b></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><b><span style='font-family:
  Poppins,Roboto'>a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><span style='font-family:Poppins,Roboto'>All prices
  quoted on the Tribly Platform are in US dollars, excluding taxes or charges
  that may apply to the particular Order.</span></p>
  
  <p class=BodyA><b><u><span style='font-family:Poppins,Roboto'><span
   style='text-decoration:none'>&nbsp;</span></span></u></b></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><b><span style='font-family:
  Poppins,Roboto'>b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><span style='font-family:Poppins,Roboto'>Any
  additional custom taxes, duties, fees, imposts, tariffs and charges that may be
  raised by particular countries or authorities related to the conclusion or
  execution of your Order shall be borne by you. In the event Tribly is required
  to pay such charges to any authority, you shall indemnify and hold harmless
  Tribly for any such payments.</span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><b><span style='font-family:
  Poppins,Roboto'>c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><span style='font-family:Poppins,Roboto'>In the
  event of obvious errors on the Tribly Platform or made in connection with your
  Order, Tribly reserves the right to correct the error and charge you the
  correct price.</span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><b><span style='font-family:
  Poppins,Roboto'>4.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><u><span style='font-family:Poppins,Roboto'>Payment
  conditions</span></u></b></p>
  
  <p class=MsoListParagraph><b><u><span style='font-family:Poppins,Roboto'><span
   style='text-decoration:none'>&nbsp;</span></span></u></b></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>You can select
  one of the payments methods described on the Tribly Platform. Tribly reserves
  the right to exclude or include particular payment methods at any time.</span></p>
  
  <p class=MsoListParagraph><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>All payment
  methods, including but not limited to credit card, PayPal or digital currency, will
  be executed by third party payment service providers using their secure
  infrastructure. Our payment service providers reserve the right to decline the
  processing of payments in cases of suspected fraud or other irregularity.</span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>All payments
  made by you shall be governed by the terms and conditions of the respective
  third party payment service provider applicable to such payment type.</span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><b><span style='font-family:
  Poppins,Roboto'>5.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><u><span style='font-family:Poppins,Roboto'>Delivery</span></u></b></p>
  
  <p class=MsoListParagraph><b><u><span style='font-family:Poppins,Roboto'><span
   style='text-decoration:none'>&nbsp;</span></span></u></b></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>Tribly will
  send the delivery email to the address indicated in your Order. </span></p>
  
  <p class=MsoListParagraph><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>The Tribly
  Platform shall facilitate the delivery of the Order upon confirmation of your
  successful payment of the purchase price. Time for delivery shall be prolonged
  by reasonable periods in case of force majeure or other events for which Tribly
  is not responsible, such as disruptions in operations, strikes, power outages,
  acts of God, pandemics, epidemics, governmental authority measures, or troubles
  with telecommunications.</span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>The NFTs shall
  remain the property of the respective artist who created such NFTs until the
  Order has been paid in full.</span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>d)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>The delivery of
  the purchased NFTs are made at the risk of the purchaser who is responsible for
  the accurate delivery of the NFTs to and from the digital wallet provider,
  Venly. By making a purchase, the purchaser acknowledges and understands that
  the purchase and handling of NFTs is highly technical and comes with a degree
  of risk unlike with the purchase of other digital assets. To that end, the
  purchaser acknowledges an adequate understanding of the purchase process and
  the NFTs being purchased.</span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><b><span style='font-family:
  Poppins,Roboto'>6.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><u><span style='font-family:Poppins,Roboto'>Use
  of Personal Information</span></u></b></p>
  
  <p class=MsoListParagraph><b><u><span style='font-family:Poppins,Roboto'><span
   style='text-decoration:none'>&nbsp;</span></span></u></b></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>To register on
  the Tribly Platform, you need to specify a login name and a password. Tribly
  further needs your contact information for issuing the invoice. You are
  responsible for keeping this information correct, confidential, and up to date.</span></p>
  
  <p class=MsoListParagraph><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>By completing
  the contact form, you ensure and take full responsibility that the entered data
  truly identifies you as a natural person or as a representative of the
  specified organization. If you place an Order on behalf of an organization, you
  ensure that you have the authority to do so.</span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>Tribly is not
  liable for any consequences that may result from incorrect, incomplete, or
  false information you have entered or from data you have changed subsequently
  to your Order.</span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>d)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>In case of
  online payments, you are required to enter your payment details. Online payment
  information related to your Order is processed by Tribly’s payment service
  providers. Tribly does not receive detailed information (such as your credit
  card number) from transactions but instead receives information about whether
  the payment has been performed successfully or not.</span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>e)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>By placing your
  Order, you agree that your contact and payment information may be used to
  process your payment and to execute your Order.</span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><b><span style='font-family:
  Poppins,Roboto'>7.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><u><span style='font-family:Poppins,Roboto'>Liability</span></u></b><span
  style='font-family:Poppins,Roboto'>.  Unless Tribly is proven to have
  defaulted intentionally or through gross negligence, claims for damages or the
  rescission of the purchase agreement on grounds of inaccurate delivery is
  excluded. Tribly’s total liability in any matter arising out of or related to
  these TOS is limited to the purchase price.</span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><b><span style='font-family:
  Poppins,Roboto'>8.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><u><span style='font-family:Poppins,Roboto'>Miscellaneous</span></u></b></p>
  
  <p class=BodyA><b><u><span style='font-family:Poppins,Roboto'><span
   style='text-decoration:none'>&nbsp;</span></span></u></b></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>Tribly may
  assign, transfer or otherwise dispose its rights and obligations under the
  purchase agreement with you, in whole or in part, at any time without notice to
  you. You may not assign the purchase agreement or transfer any rights
  hereunder.</span></p>
  
  <p class=MsoListParagraph><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>If any part of
  these TOS is or becomes legally invalid or ineffective, the validity of the
  other provisions shall not be affected thereby. In this case, the invalid or
  ineffective provision shall be replaced by a provision which comes as close as
  possible to the economic purpose of the invalid or ineffective provision.</span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>Tribly reserves
  the right to amend these TOS at any time. </span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>d)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>These TOS, the
  Website Terms of Use and Privacy Policy constitute the entire agreement between
  you and Tribly regarding your NFT purchase and supersede all previous
  agreements that may have been made. </span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>e)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>The place of
  performance regarding delivery and payment shall exclusively be Mississippi,
  United States of America.</span></p>
  
  <p class=BodyA><span style='font-family:Poppins,Roboto'>&nbsp;</span></p>
  
  <p class=MsoListParagraph style='text-indent:0in'><span style='font-family:
  Poppins,Roboto'>f)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span style='font-family:Poppins,Roboto'>These TOS shall
  be governed by Mississippi law, to the exclusion of its conflict of law rules.
  The application of the United Nation Convention on Contracts for the
  International Sale of Goods shall be excluded. The place of jurisdiction shall
  be the court having subject-matter jurisdiction in Rankin County, Mississippi. </span></p>
  
  </div>`

  return (
    <Layout title="Collections">
      <Box css={PrivacyPolicyPageStyle.FeaturedBoxStyle}>
        <Typography variant="h1">Terms of sale</Typography>
      </Box>
      <Divider />

      <Container sx={{ padding: 4 }}>
        <Box dangerouslySetInnerHTML={{ __html: html }}></Box>
      </Container>
    </Layout>
  )
}

export default PrivacyPolicyPage
